// constants
import {
    INITIALIZE_UBISOFT_CONNECT_DONE,
    INITIALIZE_UBISOFT_CONNECT_ERROR
} from './ubisoft-connect-provider.constants';

// services
import ubisoftConnectService from '../ubisoft-connect-service/service';

// constants
import { UBICONNECT_LOGGED_IN } from '../ubisoft-connect-service/constants';

// utils
import { SUCCESS_NEXT_URL } from '../ubisoft-connect-service/utils';
import { ENV } from '@sitegen/common/constants/environments';

// types
import { Dispatch } from 'types/dispatch';

export const loadUbisoftConnect = () => async (dispatch: Dispatch, getState: Function) => {
    const {
        config: { envName, genomeId, applicationId },
        language: { activeLanguageCode }
    } = getState();
    const ubisoftConnectEnvName = [ENV.PROD, ENV.PREPROD].includes(envName) ? ENV.PROD : ENV.UAT;
    const options = {
        envName: ubisoftConnectEnvName,
        applicationId,
        genomeId,
        lang: activeLanguageCode,
        topicOfPostMessage: UBICONNECT_LOGGED_IN,
        nextUrl: encodeURIComponent(SUCCESS_NEXT_URL(applicationId, genomeId))
    };

    try {
        ubisoftConnectService.init(options);
        dispatch({ type: INITIALIZE_UBISOFT_CONNECT_DONE });
    } catch {
        dispatch({ type: INITIALIZE_UBISOFT_CONNECT_ERROR });
    }
};
